/**
 * The name of the Auth.js strategy
 */
export const AUTHJS_STRATEGY_NAME = "Auth.js";
